import NetworkService from './networkService';
import { ApiUrl } from '../configs/path.config';

/**
 * Method will call default legal data.
 */
export async function getLegal() {
    let response = await NetworkService.getData(ApiUrl.getLegal());
    return response;
    
}

export async function saveEula(reqBody) {
    let response = await NetworkService.postData(ApiUrl.saveEula(), reqBody);
    return response;
}